import { render, staticRenderFns } from "./acceptDetail.vue?vue&type=template&id=a065304a&scoped=true&"
import script from "./acceptDetail.vue?vue&type=script&lang=js&"
export * from "./acceptDetail.vue?vue&type=script&lang=js&"
import style0 from "./acceptDetail.vue?vue&type=style&index=0&id=a065304a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a065304a",
  null
  
)

export default component.exports